import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class ServiceList {
    constructor($el) {
        const width = window.innerWidth;
        if (width >= 768) {
            return;
        }

        this.$el = $el;
        this.$swiper = this.$el.querySelector('[data-service-list-slider-items]');

        this.initSlider = this.initSlider.bind(this);

        this.initSlider();
    }

    initSlider() {
        new Swiper(this.$swiper, {
            spaceBetween: 24,
            loop: true,
            slidesPerView: 1,
            autoplay: { delay: 4000, },
            navigation: {
                nextEl: this.$el.querySelector(".swiper-next"),
                prevEl: this.$el.querySelector(".swiper-prev"),
            },
        });
    }
}